import { z } from 'zod';

import { requiredString } from '@/shared/utils/validation';

export const addResourcesToGroupInputSchema = z.object({
  groupId: requiredString(),
});

export type TAddResourcesToGroupInputSchema = z.infer<
  typeof addResourcesToGroupInputSchema
>;
